<!-- @format -->

<template>
	<div style="width: 100%">
		<el-input v-model="value" clearable show-word-limit v-bind="$attrs"></el-input>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		modelValue: string | null;
		options: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			console.log('set:', value);
			emit('update:modelValue', value);
		},
	});
</script>

<style lang="scss" scoped>
	.selectUserClass {
		width: 100%;
		margin-bottom: 10px;

		:deep(.selectUserPopper) {
			visibility: hidden;
		}
	}
</style>
